import './List.scss';

export const List = ({ children, customClass, ...otherProps }) => {
  return <div className={`list-component ${customClass}`} {...otherProps}>{children}</div>;
};
